
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ScrollEvent from "../../../components/scrollevent";
import "../styles/homeBannerCarousel.scss";

// 每 5 秒切換一次
const SLIDE_INTERVAL = 5000;

const slides = [
  {
    id: "brand",
    image: "/homeImg/1.jpg",
    title: "Becker CPA Exam Review",
    type: "brand",
    link: "",
    end: null,
  },
  {
    id: "moving",
    image: "/homeImg/banner-moving.png",
    title: "Becker Taiwan 喬遷優惠",
    subtitle: "指定方案最高現折 NT$5,000",
    tag: "優惠至 2026.11.15",
    link: "https://beckertw.com/home/newdetail/693",
    end: "2026-11-15T23:59:59+08:00",
  },
  {
    id: "anniversary",
    image: "/homeImg/banner-anniversary.png",
    title: "Becker Taiwan 週年慶",
    subtitle: "週年慶限定活動",
    tag: "優惠至 2026.12.20",
    link: "",
    end: "2026-12-20T23:59:59+08:00",
  },
  {
    id: "cma",
    image: "/homeImg/banner-cma.png",
    title: "中文 CMA 考場登台",
    subtitle: "2027 年 11 月台灣考場｜滿 10 人符合開考條件",
    tag: "CMA 最新消息",
    link: "https://beckertw.com/home/newdetail/694",
    end: null,
  },
];

export default function HomeBannerCarousel() {
  const [now, setNow] = useState(() => Date.now());

  // 使用 ID 記錄目前的 Banner
  const [activeId, setActiveId] = useState("brand");

  // 手動切換時，用來重新開始 5 秒計時
  const [resetCount, setResetCount] = useState(0);

  // 每分鐘更新一次時間，檢查活動是否到期
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // 過期的活動不顯示
  const availableSlides = slides.filter((slide) => {
    if (!slide.end) return true;

    return new Date(slide.end).getTime() > now;
  });

  const activeIndex = availableSlides.findIndex(
    (slide) => slide.id === activeId
  );

  const currentIndex = activeIndex >= 0 ? activeIndex : 0;
  const activeSlide = availableSlides[currentIndex];

  // 固定每 5 秒切換，不受滑鼠位置影響
  useEffect(() => {
    if (availableSlides.length <= 1) return;

    const timer = setInterval(() => {
      setActiveId((previousId) => {
        const index = availableSlides.findIndex(
          (slide) => slide.id === previousId
        );

        const current = index >= 0 ? index : 0;
        const nextIndex = (current + 1) % availableSlides.length;

        return availableSlides[nextIndex].id;
      });
    }, SLIDE_INTERVAL);

    return () => clearInterval(timer);
  }, [now, resetCount]);

  // 點擊底部指示條切換
  const goTo = (index) => {
    if (!availableSlides[index]) return;

    setActiveId(availableSlides[index].id);

    // 重新計時 5 秒
    setResetCount((prev) => prev + 1);
  };

  return (
    <section
      className="becker-banner-carousel"
      aria-label="首頁 Banner 輪播"
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={activeSlide.id}
          className="becker-banner-slide"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          {activeSlide.type === "brand" ? (
            <div className="becker-banner-brand">
              <img
                src={activeSlide.image}
                alt={activeSlide.title}
              />

              <div className="bannerblock dis" />

              <div className="bannertext dis">
                <div className="lgtext dis">
                  Becker<br />
                  <div className="lxtext">
                    CPA<br />
                  </div>
                  Exam Review<br />
                </div>

                全球最具權威領導品牌的<br />
                財會培訓軟體<br />
              </div>
            </div>
          ) : (
            <div className="becker-banner-campaign">
              <img
                className="becker-banner-image"
                src={activeSlide.image}
                alt=""
              />

              <div className="becker-banner-overlay" />

              <div className="becker-banner-content">
                <span className="becker-banner-tag">
                  {activeSlide.tag}
                </span>

                <h3>{activeSlide.title}</h3>
                <p>{activeSlide.subtitle}</p>

                {activeSlide.link ? (
                  <a
                    href={activeSlide.link}
                    className="becker-banner-button"
                  >
                    了解更多 →
                  </a>
                ) : (
                  <span className="becker-banner-pending">
                    活動詳情即將公布
                  </span>
                )}
              </div>
            </div>
          )}
        </motion.div>
      </AnimatePresence>

      {/* 底部切換指示條 */}
      {availableSlides.length > 1 && (
        <div className="becker-banner-dots">
          {availableSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              className={
                index === currentIndex ? "active" : ""
              }
              onClick={() => goTo(index)}
              aria-label={`切換至第 ${index + 1} 張 Banner`}
              aria-current={
                index === currentIndex ? "true" : undefined
              }
            />
          ))}
        </div>
      )}

      <ScrollEvent />
    </section>
  );
}
